"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinPathUniqueIds = joinPathUniqueIds;
function joinPathUniqueIds(...pathUniqueIds) {
    const joined = pathUniqueIds.filter((id) => id).join('\\');
    if (!joined.includes('\\') && joined.length > 0) {
        return `\\${joined}`;
    }
    return joined;
}
//# sourceMappingURL=PathUtils.js.map